import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import SimpleHeader from "./base/features/blocks/SimpleHeader";
import { apiService } from "./base/service/service";
import AfterPayment from "./features/afterPayment/AfterPayment";
import ConcertDetail from "./features/concert/ConcertDetail";
import Home from "./features/home/Home";
import TicketSell from "./features/salon/TicketSell";
import QrDetail from "./features/userTickets/QrDetail";
import UserTickets from "./features/userTickets/UserTickets";
import useQuery from "./base/utils/useQuery";
import LoginModal from "./features/login-modal/LoginModal";
import SideBar from "./base/features/sidebar/SideBar";
import { FiMenu } from "react-icons/fi";
import "./base/features/sidebar/Sidebar.scss";

export default function App() {
  let query = useQuery();
  const [loginModal, setLoginModal] = useState(false);

  useEffect(() => {
    checkVersion();
  }, []);
  useEffect(() => {
    if (query) {
      let token = query.get("token");
      if (token) {
        localStorage.setItem("token", token);
      }
      let login = query.get("login");
      if (login === "1" && loginModal === false) {
        setLoginModal(true);
      } else {
        setLoginModal(false);
      }
    }
  }, [query]);
  function checkVersion() {
    apiService({ url: "api/user/version", methodType: "get" }).then((data) => {
      if (data && data.success === 1) {
        var needToClearCashes = false;
        let min_version = localStorage.getItem("min_version_number");
        if (!min_version) {
          needToClearCashes = true;
        } else {
          if (min_version < data.details.ticket_min_version_number) {
            needToClearCashes = true;
          }
        }
        if (needToClearCashes) {
          try {
            caches.keys().then((names) => {
              names.forEach((name) => {
                caches.delete(name);
              });
            });
            localStorage.setItem(
              "min_version_number",
              data.details.ticket_min_version_number
            );
            window.location.reload(true);
          } catch (e) {
            console.log(e);
          }
        }
      }
    });
  }
  return (
    <div className="container-fluid px-0" dir="rtl">
      <div className="row mx-0 justify-content-center">
        <div className="col-12 col-md-10 col-lg-8 px-0 position-relative">
          <SimpleHeader logo />
          <SideBar
            right
            customBurgerIcon={<FiMenu className="header" />}
            customCrossIcon={false}
            width={"250px"}
          />
          <div>
            <Routes>
              <Route path="/" exact element={<Home />} />
              <Route
                path="/buy-ticket/:eventId/:sceneToken"
                exact
                element={<TicketSell />}
              />
              <Route
                path="/concert/:concertToken"
                exact
                element={<ConcertDetail />}
              />
              <Route path="/my-ticket-list" exact element={<UserTickets />} />
              <Route path="/qr/:code" exact element={<QrDetail />} />
              <Route
                path="/pay/result/:status/:code/:price"
                exact
                element={<AfterPayment />}
              />
            </Routes>
          </div>
        </div>
      </div>
      <LoginModal
        acceptModalChange={() => window.history.back()}
        acceptModal={loginModal ? true : false}
      />
    </div>
  );
}
